import { Breadcrumb } from "@gull";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import overlayFactory from "react-bootstrap-table2-overlay";
import HandyScroll from "app/common/Scroll";
import queryString from "app/services/queryStringService";
import config from "config.json";
import moment from "moment";
import Tooltip from "rc-tooltip";
import {
  Badge,
  Button,
  Col,
  Dropdown,
  DropdownButton,
  Image,
  Row,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { FaArrowsAltH, FaLongArrowAltRight, FaUserCheck } from "react-icons/fa";
import { MdOutlineRefresh, MdSearch, MdSystemUpdateAlt } from "react-icons/md";
import PassengerModal from "./Components/Booking/PassengerModal"; //./PassengerModal.jsx";
import TicketModal from "./Components/Booking/TicketModal";
import {
  ExportBookingHistory,
  getBookingHistory,
} from "./Components/Service/bookingService";

import { AiFillFileExcel } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
// import MemberAutoComplete from "./Components/MemberAutoComplete";

function BookingHistory() {
  const { dateTimeFormat } = config;
  const [isShowGlobalFilter, setIsShowGlobalFilter] = useState(true);
  // const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  // console.log({ canAdd, canView, canEdit, canDelete });
  const navigate = useNavigate();
  const [showPassenger, setShowPassenger] = useState(false);
  const [showJourney, setShowJourney] = useState(false);

  const [showTicketModal, setShowTicketModal] = useState(false);
  const [ticketData, setTicketData] = useState({});
  const [passengers, setPassengers] = useState([]);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [SearchBy, setSearchBy] = useState("Booking");
  const [totalBookingAmount, setTotalBookingAmount] = useState(null);
  const [agentValue, setAgentValue] = useState();
  const [toDate, setToDate] = useState("");
  const [pnr, setPnr] = useState();
  const [selectedValue, setSelectedValue] = useState(null);
  const [show, setShow] = useState(false);
  const [bookingStatus, setBookingStatus] = useState("");
  const [depart, setDepart] = useState("");
  const [arrival, setArrival] = useState("");
  const [paxName, setPaxName] = useState("");
  const modalClose = () => setShow(false);

  const dateFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        <div>{moment(cell).format("DD/MM/YYYY")}</div>
        <div>{moment(cell).format("HH:mm")}</div>
      </div>
    );
  };

  async function getJourneyDetails(e, value) {
    setPassengers(value);
    setShowJourney(true);
  }

  function handlePassengerClose() {
    setShowPassenger(false);
  }
  function handleJourneyClose() {
    setShowJourney(false);
  }

  function handleClose() {
    setShowTicketModal(false);
  }
  const priceFormatter = (cell, row) => (
    <span className="text-center">₹ {parseFloat(cell).toFixed(2)}</span>
  );
  const gatewayFormatter = (cell, row) => {
    return cell == "TRAVELPORT_GAL" ? "TRAVELPORT GAL" : cell;
  };

  const JourneyType = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        {row.journeyType == 1 ? (
          <>
            <div style={{ marginBottom: 5 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="20"
                      width={"20"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="20"
                    width={"20"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg={row.isDomestic == true ? "info" : "danger"}>
                {row.isDomestic == true ? "Domestic" : "International"} Oneway
              </Badge>
            </h6>
          </>
        ) : row.journeyType == 2 ? (
          <>
            <div style={{ marginBottom: 5, borderRadius: 15 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="20"
                      width={"20"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="20"
                    width={"20"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg="warning" style={{ color: "black" }}>
                Domestic Return
              </Badge>
            </h6>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 5 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="22"
                      width={"22"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="22"
                    width={"22"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg="primary">International Return</Badge>
            </h6>
          </>
        )}
      </div>
    );
  };

  const flightFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <>
        {row.journeyType == 1 ? (
          <Tooltip
            placement="top"
            overlay={
              <div style={{ maxWidth: 250 }}>
                {row.airportDeparture.cityName} <FaLongArrowAltRight />{" "}
                {row.airportDestination.cityName}
              </div>
            }
          >
            <span>
              {row.airportDeparture.cityCode} <FaLongArrowAltRight />{" "}
              {row.airportDestination.cityCode}
            </span>
          </Tooltip>
        ) : (
          <Tooltip
            placement="top"
            overlay={
              <div style={{ maxWidth: 250 }}>
                {row.airportDeparture.cityName} <FaArrowsAltH />{" "}
                {row.airportDestination.cityName}
              </div>
            }
          >
            <span>
              {row.airportDeparture.cityCode} <FaArrowsAltH />{" "}
              {row.airportDestination.cityCode}
            </span>
          </Tooltip>
        )}
      </>
    );
  };
  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          {row.currentStatus == "COMPLETED" || row.currentStatus == "REFUND" ? (
            ""
          ) : (
            <Dropdown.Item
              // href="#"
              className="text-primary"
              data-bs-toggle="modal"
              data-bs-target="#virtualbank"
              onClick={(e) => getJourneyDetails(e, row)}
            >
              <MdSystemUpdateAlt className="text-primary me-4"></MdSystemUpdateAlt>
              Update PNR
            </Dropdown.Item>
          )}
          <Dropdown.Item
            className="text-primary"
            onClick={() =>
              navigate(`/supplier/flight/booking-details/${row.id}`)
            }
          >
            <FaUserCheck className="text-primary me-4" />
            Booking Details
          </Dropdown.Item>
        </DropdownButton>
      </>
    );
  };
  const CarrierChargesFormatter = (cell, row) => {
    return (
      <>
        {row.flightCommissionType == "Negative" ? (
          <span className="text-center" style={{ color: "red" }}>
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        ) : row.flightCommissionType == "Positive" ? (
          <span className="text-center" style={{ color: "green" }}>
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        ) : (
          <span className="text-center text-primary">
            ₹ {parseFloat(cell).toFixed(2)}
          </span>
        )}
      </>
    );
  };

  const userType = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <>
        <Row>
          <Col
            style={{
              textTransform: "uppercase",
            }}
          >
            <div>{row?.masterMember?.company}</div>
            <div>{row.user.normalizedUserName}</div>
          </Col>
        </Row>
      </>
    );
  };
  const bookBy = (cell, row) => {
    const value = row?.bookedByUser || "";
    const parts = value.split("-");

    let role = "";
    let userId = "";
    let name = "";

    if (parts.length >= 4) {
      role = `${parts[0]} ${parts[1]}`; // Sub-Merchant
      userId = parts[2];
      name = parts.slice(3).join("-"); // handles extra hyphens
    } else if (parts.length === 3) {
      role = parts[0];
      userId = parts[1];
      name = parts[2];
    }

    return (
      <Row>
        {row?.bookedByUser ? (
          <Col
            style={{
              textTransform: "uppercase",
            }}
          >
            <div>
              {userId} ({role})
            </div>
            {/* <div>{userId}</div> */}
            <div>{name}</div>
          </Col>
        ) : (
          <Col>-</Col>
        )}
      </Row>
    );
  };

  const pnrFormatter = (cell, row) => {
    return (
      <>
        {row.currentStatus == "PENDING" || row.currentStatus == "REFUND" ? (
          ""
        ) : (
          <Tooltip placement="top" overlay={<div>{row.pnr}</div>}>
            <span>
              <Button variant="outline-primary" size="sm">
                Check PNR
              </Button>
            </span>
          </Tooltip>
        )}
      </>
    );
  };
  const columns = [
    {
      dataField: "id",
      text: "Action",
      formatter: actionFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
    },
    {
      dataField: "journeyType",
      text: "Airlines",
      formatter: JourneyType,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },

    {
      dataField: "invoiceDate",
      text: "Booking Date",
      formatter: dateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDeparture.cityCode",
      text: "From - To",
      formatter: flightFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "departureDate",
      text: "Journey Date",
      formatter: dateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },

    {
      dataField: "pnr",
      text: "PNR",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: pnrFormatter,
    },
    {
      dataField: "currentStatus",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },

    // {
    //   dataField: "user.normalizedUserName",
    //   text: "User",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "200px", textAlign: "center" };
    //   },
    //   formatter: userType,
    // },
    // {
    //   dataField: "subMerchantName",
    //   text: "Book By",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "250px", textAlign: "center" };
    //   },
    //   formatter: bookBy,
    // },
    // {
    //   dataField: "",
    //   text: "Update PNR",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "150px", textAlign: "center" };
    //   },

    //   formatter: actionFormatter,
    // },
    {
      dataField: "netTotalFare",
      text: "Booked Price",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    // {
    //   dataField: "apiGateway",
    //   text: "Gateway",

    //   headerStyle: (colum, colIndex) => {
    //     return { width: "110px", textAlign: "center" };
    //   },
    //   formatter: gatewayFormatter,
    // },
    // {
    //   dataField: "bookingMode",
    //   text: "Booking Mode",

    //   headerStyle: (colum, colIndex) => {
    //     return { width: "110px", textAlign: "center" };
    //   },
    // },
    // {
    //   dataField: "totalCarrierServiceCharges",
    //   text: "Commission",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "120px", textAlign: "center" };
    //   },
    //   formatter: CarrierChargesFormatter,
    // },
    // {
    //   dataField: "adminMarkupAmount",
    //   text: "Markup",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "80px", textAlign: "center" };
    //   },
    //   formatter: priceFormatter,
    // },
    // {
    //   dataField: "tdsAmount",
    //   text: "TDS Amount",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "150px", textAlign: "center" };
    //   },
    //   formatter: priceFormatter,
    // },
    // {
    //   dataField: "adminSGst",
    //   text: "Ticket ",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "150px", textAlign: "center" };
    //   },
    //   formatter: ticketFormatter,
    // },
    {
      dataField: "refundStatus",
      text: "Refund Status",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },
  ];

  function rowStyle(row, rowIndex) {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    if (row.currentStatus === "REJECTED") {
      style.backgroundColor = "#DCDCDC";
    }
    if (row.hasFrequentFlyer) {
      style.backgroundColor = "#f5ebff";
    }
    return style;
  }

  function NoDataIndication() {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  }
  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "fromDate":
        setFromDate(value);
        break;
      case "toDate":
        setToDate(value);
        break;
      case "pnr":
        setPnr(value);
        break;
      case "SearchBy":
        setSearchBy(value);
        break;
      case "agentValue":
        setAgentValue(value);
        break;
      case "bookingStatus":
        setBookingStatus(value);
        break;
      case "depart":
        setDepart(value);
        break;
      case "arrival":
        setArrival(value);
        break;
      case "paxName":
        setPaxName(value);
        break;

      default:
        break;
    }
  };
  async function loadBookingDetails() {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      fromDate,
      toDate,
      SearchBy,
      pnr,
      agentValue,
      transactionStatus: bookingStatus,
      FromOrigin: depart,
      ToDestination: arrival,
      PassengerName: paxName,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getBookingHistory(query);

    const getDistinctRecords = (data) => {
      const seenCoRelationIds = new Set();
      const result = [];

      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        // If combo is false and not null, treat as separate, set journeyType to 1
        if (item.combo === false && item.combo !== null) {
          result.push(item);
          continue;
        }
        // Otherwise, merge based on coRelationId
        if (!seenCoRelationIds.has(item.coRelationId)) {
          seenCoRelationIds.add(item.coRelationId);

          const filteredData = data.filter(
            (entry) => entry.coRelationId === item.coRelationId,
          );

          const lastOccurrence = filteredData[filteredData.length - 1];

          if (lastOccurrence.journeyType == 2) {
            lastOccurrence.netTotalFare = filteredData.reduce(
              (sum, entry) => sum + entry.netTotalFare,
              0,
            );
          }

          if (
            lastOccurrence.journeyType == 2 ||
            lastOccurrence.journeyType == 3
          ) {
            lastOccurrence.totalCarrierServiceCharges = filteredData.reduce(
              (sum, entry) => sum + entry.totalCarrierServiceCharges,
              0,
            );
            lastOccurrence.tdsAmount = filteredData.reduce(
              (sum, entry) => sum + entry.tdsAmount,
              0,
            );
          }

          // ✅ Check all passengers across entries with the same coRelationId
          const hasFrequentFlyer = filteredData.some(
            (entry) =>
              entry.passengerList &&
              entry.passengerList.some(
                (passenger) =>
                  passenger.frequentFlyerNo &&
                  passenger.frequentFlyerNo.trim() !== "",
              ),
          );

          lastOccurrence.hasFrequentFlyer = hasFrequentFlyer;

          result.push(lastOccurrence); // ✅ Push the final object
        }
      }
      // console.log(result);

      return result;
    };

    const distinctRecords = getDistinctRecords(response.data.data);
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setLoading(false);
    setData(distinctRecords);
    setDataCount(paggingData.TotalCount);
  }

  useEffect(() => {
    loadBookingDetails();
  }, [
    page,
    sizePerPage,
    fromDate,
    toDate,
    pnr,
    SearchBy,
    agentValue,
    bookingStatus,
    // depart,
    // arrival,
    // paxName,
  ]); // Call loadBookingDetails whenever page or sizePerPage changes
  useEffect(() => {
    const isValid =
      (depart && depart.length >= 3) ||
      (arrival && arrival.length >= 3) ||
      (paxName && paxName.length >= 3);

    if (!isValid) return;

    const timer = setTimeout(() => {
      setPage(1); // reset pagination
      loadBookingDetails();
    }, 500); // debounce

    return () => clearTimeout(timer);
  }, [depart, arrival, paxName]);

  function handleTableChange(type, { page, sizePerPage }) {
    setPage(page);
    setSizePerPage(sizePerPage);
  }

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setLoading(true);
    await loadBookingDetails();
  };
  const refreshFilter = (e) => {
    setFromDate("");
    setToDate("");
    setPnr("");
    setSearchBy("");
    setAgentValue();
    setSelectedValue(null);
    setBookingStatus("");
    setDepart("");
    setArrival("");
    setPaxName("");
  };
  const exportAllReq = async () => {
    const query = queryString.getQueryStringFromObj({
      fromDate,
      SearchBy,
      toDate,
      pnr,
      agentValue,
      TransactionStatus: bookingStatus,
      FromOrigin: depart,
      ToDestination: arrival,
      PassengerName: paxName,
    });
    if (dataCount != 0) {
      setLoading(true);
    }

    const response = await ExportBookingHistory(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_Flight_Booked_List.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setLoading(false);
  };
  const handleExport = async () => {
    setPage(page);
    setSizePerPage(sizePerPage);

    setTimeout(async () => {
      await exportAllReq();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const refreshGlobalFilter = async (e) => {
    setIsShowGlobalFilter(!isShowGlobalFilter);
  };

  return (
    <>
      <Helmet>
        <title>Booking History</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Booking History" }]}></Breadcrumb>
      <div className="bookingList-header" style={{ marginBottom: 20 }}>
        <Row>
          <Row className="align-items-center mb-2">
            <Col className="col-md-12 d-flex justify-content-end mt-1">
              <Button
                variant="primary"
                className="mx-2"
                onClick={refreshGlobalFilter}
              >
                {isShowGlobalFilter ? (
                  <>
                    Filter <i className="i-Filter-2 mt-1" />
                  </>
                ) : (
                  <i className="i-Filter-2 mt-1" />
                )}
              </Button>

              <Button
                variant="primary"
                onClick={handleExport}
                disabled={!dataCount}
              >
                {isShowGlobalFilter ? (
                  <>
                    Export <AiFillFileExcel size={15} />
                  </>
                ) : (
                  <AiFillFileExcel size={15} />
                )}
              </Button>
            </Col>
          </Row>
          <div className={isShowGlobalFilter ? "collapse" : "show"}>
            <div className="card card-body rounded border mb-1">
              <Row>
                {/* Search By */}
                <Col md={2} col={12}>
                  <label>Search By</label>
                  <select
                    className="form-select"
                    name="SearchBy"
                    value={SearchBy}
                    onChange={handleSearchChanges}
                  >
                    <option value="Booking">Booking</option>
                    <option value="Travel">Travel</option>
                  </select>
                </Col>
                {/* Date From */}
                <Col md={2} col={12}>
                  <label>Date From</label>
                  <input
                    type="date"
                    className="form-control"
                    name="fromDate"
                    value={fromDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </Col>
                {/* Date To */}
                <Col md={2} col={12}>
                  <label>Date To</label>
                  <input
                    type="date"
                    className="form-control"
                    name="toDate"
                    value={toDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </Col>
                {/* PNR */}
                <Col md={2} col={12}>
                  <label>PNR</label>
                  <input
                    type="text"
                    className="form-control"
                    name="pnr"
                    placeholder="PNR"
                    value={pnr}
                    onChange={handleSearchChanges}
                  />
                </Col>
                {/* Booking Status */}
                <Col md={2} col={12}>
                  <label>Booking Status</label>
                  <select
                    className="form-select"
                    name="bookingStatus"
                    value={bookingStatus}
                    onChange={handleSearchChanges}
                  >
                    <option value="">Select option</option>
                    <option value="Completed">Completed</option>
                    <option value="Pending">Pending</option>
                    <option value="Refund">Refund</option>
                    <option value="Partial Cancelled">
                      Partial Cancellation
                    </option>
                    <option value="Fully Cancelled">Fully Cancellation</option>
                    <option value="Hold">Hold</option>
                    <option value="Unconfirmed">Unconfirmed</option>
                  </select>
                </Col>
                {/* Depart */}
                <Col md={2} col={12}>
                  <label>Origin (From)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="depart"
                    placeholder="Origin (From)"
                    value={depart}
                    onChange={handleSearchChanges}
                  />
                </Col>{" "}
                {/* Arrival */}
                <Col md={2} col={12}>
                  <label>Destination (To)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="arrival"
                    placeholder="Destination (To)"
                    value={arrival}
                    onChange={handleSearchChanges}
                  />
                </Col>{" "}
                {/* PNR */}
                <Col md={2} col={12}>
                  <label>Pax Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="paxName"
                    placeholder="Pax Name"
                    value={paxName}
                    onChange={handleSearchChanges}
                  />
                </Col>
                {/* Action Buttons */}
                <Col md={12} className="d-flex justify-content-end mt-3">
                  <button
                    className="btn btn-outline-primary me-2"
                    onClick={handleSearch}
                  >
                    <MdSearch size={18} />
                  </button>

                  <button
                    className="btn btn-outline-primary"
                    onClick={refreshFilter}
                  >
                    <MdOutlineRefresh size={18} />
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        </Row>
      </div>
      <HandyScroll>
        <div
          className="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={columns}
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
      {showTicketModal && (
        <TicketModal
          show={showTicketModal}
          handleClose={handleClose}
          response={ticketData}
        />
      )}
      {showPassenger && (
        <PassengerModal
          show={showPassenger}
          handleClose={handlePassengerClose}
          response={passengers}
        />
      )}
    </>
  );
}

export default BookingHistory;
